import { createPortal } from "react-dom";
import "./ConfirmModal.css";

export default function ConfirmModal({
  open,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  danger = false,
  loading = false,
  error = "",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return createPortal(
    <div className="cm-overlay" onClick={loading ? undefined : onCancel}>
      <div
        className="cm-box"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="cm-title">{title}</h3>
        {message && <p className="cm-message">{message}</p>}
        {error && <p className="cm-error">{error}</p>}

        <div className="cm-actions">
          <button type="button" className="cm-btn cm-cancel" onClick={onCancel} disabled={loading}>
            {cancelText}
          </button>
          <button
            type="button"
            className={`cm-btn ${danger ? "cm-danger" : "cm-confirm"}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Please wait..." : confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}